import { domainConfig as realEstate } from "./realEstate";
import { domainConfig as restaurant } from "./restaurant";
import { domainConfig as ecommerce } from "./ecommerce";
import { domainConfig as healthcare } from "./healthcare";
import { domainConfig as education } from "./education";
import { domainConfig as finance } from "./finance";
import { domainConfig as professional } from "./professional";
import { domainConfig as insurance } from "./insurance";
import { domainConfig as other } from "./other";

export const DOMAINS = {
  "real-estate": realEstate,
  restaurant: restaurant,
  ecommerce: ecommerce,
  healthcare: healthcare,
  education: education,
  finance: finance,
  professional: professional,
  insurance: insurance,
  other: other,
};

export const getDomainConfig = (domainId) => {
  if (!DOMAINS[domainId]) {
    console.warn(`Domain ${domainId} not found, using default`);
    return DOMAINS[getDefaultDomain()];
  }
  return DOMAINS[domainId];
};

export const getAllDomains = () => {
  return Object.entries(DOMAINS).map(([id, config]) => ({
    id,
    name: config.name,
    icon: config.icon,
    description: config.description,
  }));
};

export const getDefaultDomain = () => "real-estate";
export const isDomainValid = (domainId) => !!DOMAINS[domainId];

// Validation functions
export const validateDomainConfig = (config) => {
  const required = [
    "id",
    "name",
    "projectTypes",
    "contentTypes",
    "defaults",
    "labels",
  ];
  return required.every((field) => config[field]);
};
